import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { SemiCircleProgress } from './SemiCircleProgress';
import { formatValueWithoutCurrency } from '../../../helpers/currency.helper';

interface BalanceUpDonutProps {
  percentage: number;
  currencySign: string;
  currencyAmount: number;
  disabled?: boolean;
  danger?: boolean;
  isEligible: boolean;
}

const BalanceUpDonut = ({
  percentage,
  currencySign,
  currencyAmount,
  disabled,
  danger,
  isEligible,
}: BalanceUpDonutProps) => {
  const { t } = useTranslation('balanceUpTranslation');

  return (
    <div className='relative w-fit mt-[12px]'>
      <div className='flex flex-col items-top items-center absolute left-[50%] top-[64%] translate-x-[-50%] translate-y-[-50%]'>
        <div
          className={`flex flex-row items-top ${disabled ? 'text-text-main-disabled' : danger ? 'text-outline-orange-primary' : 'text-text-brand-primary'}`}
          id='balance-up-percentage'
        >
          <Heading.H8 className=' mt-[4px] text-inherit'>
            {!isEligible && currencyAmount > 0 ? `-${currencySign}` : currencySign}
          </Heading.H8>
          <Heading.H3 fontWeight={FontWeight.SEMIBOLD} className='text-inherit' id='percentage'>
            {formatValueWithoutCurrency(currencyAmount, 2)}
          </Heading.H3>
        </div>
        <Heading.H10
          className={`w-[142px] text-center ${disabled ? 'text-text-main-disabled' : 'text-text-main-tertiary'}`}
          id='balance-up-donut-text'
        >
          {isEligible ? t('DASHBOARD.AVAILABLE') : t('DASHBOARD.YOUR_DEBT')}
        </Heading.H10>
      </div>
      <SemiCircleProgress
        percentage={percentage}
        size={{
          width: 212,
          height: 212,
        }}
        strokeWidth={7}
        disabled={disabled}
        danger={danger}
      />
    </div>
  );
};

export default BalanceUpDonut;
